module.exports = __webpack_public_path__ + "static/img/5.1a1068f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Seguro-salud/5.png
// module id = odwy
// module chunks = 0